import { useParams } from 'next/navigation';
import { useEffect, PropsWithChildren } from 'react';

import { useSiteStore } from '@/store/site';
import { useAccountInfo } from '@/hooks/query/account';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { OddsService } from '@nf/odds/services/odds.service';
import { usePrevious } from '@nf/utils-common/hooks';

export function OddsServiceAccountProvider({ children }: PropsWithChildren) {
	const params = useParams();
	const { user, isError } = useAccountInfo();
	const setOddsServiceReady = useSiteStore(state => state.setOddsServiceReady);
	const { SiteConfigsData, isLoading } = useGetSiteConfigs();

	const oddsToken = SiteConfigsData?.EnableOddsServerApiBackend 
		? user?.AccessToken
		: user?.OddsServerToken;
	const prevOddsToken = usePrevious(oddsToken);

	useEffect(() => {
		if (isLoading || isError || !user || oddsToken === prevOddsToken) {
			return;
		}

		const oddsService = OddsService.getInstance();
		oddsService.init({
			token: oddsToken ?? '',
			oddsServerUrl: user.OddsServerUrl,
			locale: params.locale as string,
			actStatus: user.ActStatus,
			isBefore: false,
		});
		setOddsServiceReady(true);
	}, [isLoading, isError, user, params.locale, oddsToken]);
	
	return (
		<>{children}</>
	);
}